/** @jsxImportSource @emotion/react */

import { Link } from "react-router-dom";
import { buttonStyle } from "../styles";
import * as colors from "../styles/colors";

function Header({ children }) {
  return (
    <div
      css={{
        padding: "1em 2em",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Link
        to="/"
        css={{
          ...buttonStyle,
          textDecoration: "none",
          fontWeight: 900,
          color: colors.white,
        }}
      >
        Home
      </Link>
      <div>{children}</div>
      <div css={{ fontWeight: 900, fontSize: "1.6em" }}>BETA</div>
    </div>
  );
}

export { Header };
